import { createSelector } from 'reselect';
import values from 'ramda/es/values';
import prop from 'ramda/es/prop';
import groupBy from 'ramda/es/groupBy';


const selectDishes = createSelector(
  ({ items }) => items,
  values,
);

export const selectDishesByCategory = createSelector(
  [
    selectDishes,
  ],
  groupBy(prop('category_id')),
);

export default selectDishes;
